import { useState, useEffect } from 'react';

const useMangaFetch = () => {
  const [mangaItems, setMangaItems] = useState([]); // State to store manga items
  const [isLoading, setIsLoading] = useState(true); // Loading state

  useEffect(() => {
    const fetchMangaItems = async () => {
      try {
        const response = await fetch('https://api.mangadex.org/v2/manga');
        const data = await response.json();
        console.log('Fetched manga data:', data); // Log the fetched data
        setMangaItems(data.data);  // Assuming the API returns manga items in `data` field
        setIsLoading(false);  // Set loading to false after data is fetched
      } catch (error) {
        console.error('Error fetching manga data:', error);
        setIsLoading(false);  // Set loading to false in case of error
      }
    };

    fetchMangaItems();  // Fetch manga data when component mounts
  }, []);  // Empty dependency array so it runs only once on mount

  return { mangaItems, isLoading };  // Return fetched data and loading state
};

export default useMangaFetch;
